import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '~/store/composable';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReferMyTheaterButton',
  setup(__props) {

const { commit } = useStore();

function toggleReferral() {
  commit('toggleReferralDialog', true);
}

return { __sfc: true,commit, toggleReferral }
}

})